import React from "react";
import {Route} from "react-router-dom";
import {RouteProps} from "react-router";

interface OpenRouteProps extends RouteProps {
    component: any;
}

/**
 * OpenRoute — renders its component regardless of authentication state.
 * Use for public surfaces that must be accessible to both guests and logged-in users.
 */
const OpenRoute: React.FC<OpenRouteProps> = ({component: Component, ...rest}) => {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default OpenRoute;
